import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadViolationListFailed, loadViolationListSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadViolationList(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/violation-list`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK && data && data.data) {
      yield put(loadViolationListSuccessful(data.data));
      yield call(resolveActionPromise(action));
    } else {
      yield put(loadViolationListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadViolationListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
